import { render, staticRenderFns } from "./FaceCameraUploader.vue?vue&type=template&id=4b2b540f&scoped=true"
import script from "./FaceCameraUploader.vue?vue&type=script&lang=js"
export * from "./FaceCameraUploader.vue?vue&type=script&lang=js"
import style0 from "./FaceCameraUploader.vue?vue&type=style&index=0&id=4b2b540f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2b540f",
  null
  
)

export default component.exports